import { StaticQuery, graphql } from "gatsby";
import React from "react";

import {
  Section,
  Image,
  Card,
  Header2,
  Underlined,
  Paragraph,
} from "@racepointenergy/gatsby-theme-sitespark/src/components/Hero";
import { getSize } from "@racepointenergy/gatsby-theme-sitespark/src/components/Theme/utils";

// import IndependenceBg from "images/independence.png";

export const EnergyIndependence = () => (
  <Section
    css={`
      @media screen and (min-width: ${getSize("tablet720")}) {
        justify-content: flex-end;
      }
    `}
  >
    <StaticQuery
      query={graphql`
        query EnergyIndependenceHeroImageQuery {
          file(relativePath: { eq: "independence.png" }) {
            ...HeroImage
          }
        }
      `}
      render={({ file }) => (
        <Image
          alt="A well-lit home in the evening"
          css={`
            + picture > img,
            img {
              object-position: 20% 50%;
              @media screen and (min-width: ${getSize("mobile480")}) {
                object-position: -130px 50%;
              }
              @media screen and (min-width: ${getSize("tablet720")}) {
                object-position: -270px 50%;
              }
              @media screen and (min-width: ${getSize("tablet768")}) {
                object-position: -290px 50%;
              }
              @media screen and (min-width: ${getSize("tablet960")}) {
                object-position: 50% 50%;
              }
            }
          `}
          file={file}
        />
      )}
    />
    <Card
      css={`
        @media screen and (min-width: ${getSize(
            "mobile480"
          )}) and (max-width: 719px) {
          padding: 33px 46px 46px 47px;
        }
        @media screen and (min-width: ${getSize(
            "tablet720"
          )}) and (max-width: 767px) {
          padding: 40px 46px 42px 50px;
          width: 353px;
        }
        @media screen and (min-width: ${getSize("tablet768")}) {
          margin-top: -96px;
          width: 378px;
        }
        @media screen and (min-width: ${getSize("tablet960")}) {
          margin-top: unset;
          padding: 40px 46px 46px 50px;
          width: 415px;
        }
        @media screen and (min-width: ${getSize("desktop1200")}) {
          width: 433px;
        }
        @media screen and (min-width: ${getSize("desktop1920")}) {
          padding: 76px 80px 70px 80px;
          width: 607px;
        }
      `}
    >
      <Header2
        css={`
          @media screen and (min-width: ${getSize("desktop1920")}) {
            white-space: nowrap;
          }
        `}
      >
        {"Energy Independence"}
        <Underlined />
      </Header2>
      <Paragraph
        css={`
          @media screen and (min-width: ${getSize(
              "mobile480"
            )}) and (max-width: 719px) {
            margin-top: 23px;
          }
          @media screen and (min-width: ${getSize(
              "tablet720"
            )}) and (max-width: 767px) {
            margin-top: 14px;
          }
          @media screen and (min-width: ${getSize("tablet768")}) {
            width: 278px;
          }
          @media screen and (min-width: ${getSize("tablet960")}) {
            margin-top: 24px;
            width: 320px;
          }
          @media screen and (min-width: ${getSize("desktop1200")}) {
            width: 338px;
          }
          @media screen and (min-width: ${getSize("desktop1920")}) {
            width: 410px;
          }
        `}
      >
        {
          "Reliable, clean power whenever you need it. The Savant Power Micro Grid keeps the power on when the utility grid fails. With the press of a button, you can proactively disconnect from the utility grid to ensure clean, reliable power."
        }
      </Paragraph>
    </Card>
  </Section>
);
